
import 'angular-ui-bootstrap';

import 'bfc-messages/dist/bfc-messages';
import 'bfc-dialog/dist/bfc-dialog';
import 'bfc-focus/dist/bfc-focus';
import 'bfc-loading/dist/bfc-loading';
import 'bfc-mask/dist/bfc-mask';
import 'bfc-number/dist/bfc-number';
import 'bfc-permissions/dist/bfc-permissions';
import 'bfc-popover/dist/bfc-popover';
import 'bfc-select2/dist/bfc-select2';
import 'bf-search/dist/bf-search.min';
import 'bfc-undo/dist/bfc-undo';
import 'bfc-utils/dist/bfc-utils';
import 'bfc-validators/dist/bfc-validators';
import 'ui-components/dist/ui-components';
import 'bf-components/dist/bf-components';

import 'lodash';
import moment from 'moment';

import { applyPolyfills, defineCustomElements } from '@betha-plataforma/estrutura-componentes/loader';

import '../assets'

import States from './states';
import constants from './constants';
import contexto from './contexto';

const MODULE_NAME = 'app';

export default angular.module(MODULE_NAME, [
  'bfc',
  'bfc.config',
  'bfc.context-initializer',
  'bfc.dialog',
  'bfc.focus',
  'bfc.loading',
  'bfc.mask',
  'bfc.messages',
  'bfc.notifications',
  'bfc.number',
  'bfc.oauth2',
  'bfc.permissions',
  'bfc.popover',
  'bfc.search',
  'bfc.state',
  'bfc.util.select2',
  'bfc.validators',
  'user-accounts-ui',

  // Externos
  'ui.bootstrap',
  'ui.sortable',

  // GitLab
  'ui-components',
  'bf-components',

  // Componentes
  contexto.name
])
  .constant('URL_API', config.api.autorizacoes)
  .constant('URL_BASE_APP', window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''))
  .constant('AUTHENTICATION_MAIN_REDIRECT_URL', window.location.origin + '/auth/callback.html')
  .constant('CONSTANTS', constants)
  .config([() => {
    moment.locale('pt-BR');
  }])
  .config([
    'bfc.initializerProvider',
    function (initializer) {
      initializer.config({
        hints: [
          {
            url: 'entidades',
            value: 'entidade',
            accepts: [{ key: 'entidade' }],
          },
        ],
        state: {
          value: 'entidade',
        },
      });
    },
  ])
  .config(['RestangularProvider', 'URL_API', function (restangularProvider, URL_API) {
    restangularProvider.setBaseUrl(URL_API);

    restangularProvider.setResponseExtractor(function (data, operation, what, url, response) {
      if (response.status === 201 && operation === 'post' && data === '') {
        let location = response.headers('Location');

        if (location !== null && location !== undefined) {
          let fragments = location.split('/'),
            id = parseInt(fragments[fragments.length - 1], 10);

          data = {
            id: id,
            location: location,
          };
        }
      } else if (operation === 'getList') {
        let dataCopy = angular.copy(data);

        if (!_.isArray(dataCopy)) {
          let arrayData = [];

          arrayData.push(dataCopy);

          return arrayData;
        }
      }

      return data;
    });
  }])
  .config(['bfc.AppConfigProvider', function (Config) {
    Config.set({
      initialState: {
        state: 'main.entidade',
      },
    });
  }])
  .config(States)
  .factory('FilterEncodedHandler', function () {
    let obj = {
      request: function (config) {
        if (
          config.url.indexOf('api/agencias-bancarias') < 0 &&
          !angular.isUndefined(config.params) &&
          !angular.isUndefined(config.params.filter) &&
          config.params.filter.indexOf('%25') > -1
        ) {
          config.params.filter = decodeURI(config.params.filter);
        }
        return config;
      },
    };

    return obj;
  })
  .config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('bfc.messages.ErrorNotificationHandler');
  }])
  .run(['$q', '$rootScope', 'bfc.authentication.AuthenticationService', 'bfc.authentication.AuthenticationContext', 'UserAccessContext', 'bfc.Notification',
    ($q, $rootScope, authenticationService, authenticationContext, userAccessContext, notificationService) => {
      let userInfo = authenticationContext.getUserInfo();
      function getAuthorization() {
        return {
          accessId: userAccessContext.getUserAccess() && userAccessContext.getUserAccess().id,
          accessToken: authenticationContext.getAccessToken(),
        };
      }

      function handleUnauthorizedAccess() {
        authenticationService.authenticationExpired();

        let unregisterEventHandler;
        return $q(function (resolve) {
          unregisterEventHandler = $rootScope.$on('bfc:authentication:new-token', function onRenewToken(tokenRefreshed) {
            resolve(tokenRefreshed);
          });
        }).finally(unregisterEventHandler);
      }

      applyPolyfills().then(function () {
        defineCustomElements(window);
      });

      (async () => {
        await customElements.whenDefined('bth-app');

        let authorization = {
          getAuthorization: getAuthorization,
          handleUnauthorizedAccess: handleUnauthorizedAccess,
        };

        let contaUsuarioElement = document.querySelector('bth-conta-usuario');
        contaUsuarioElement.usuario = userInfo.id;
        contaUsuarioElement.nome = userInfo.nome;
        contaUsuarioElement.fotoUrl = userInfo.foto;
        contaUsuarioElement.addEventListener('logout', () => authenticationService.logout());

        let notificacoesElement = document.querySelector('bth-notificacoes');
        notificacoesElement.authorization = authorization;
        notificacoesElement.addEventListener('novaNotificacaoComLink', function onNovaNotificacaoComLink(notification) {
          notificationService.publish(notification.texto, 'success', {
            label: notification.link.label,
            onclick: function onclick() {
              window.open(notification.link.href, notification.link.target);
            }
          });
        });

        let novidadesElement = document.querySelector('bth-novidades');
        novidadesElement.authorization = authorization;
      })();
    }]);
